import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

const BRANDS = [
  "Shure", "Sennheiser", "Pioneer DJ", "QSC", "RCF", "d&b audiotechnik",
  "Hikvision", "Dahua", "Robe", "Chauvet", "Behringer", "Powersoft",
];

export const PartnerCarousel = () => {
  const { lang } = useLang();
  const list = [...Array(2)].flatMap((_, dup) =>
    ["amate", ...BRANDS].map((b) => ({ brand: b, key: `${dup}-${b}` }))
  );

  return (
    <section className="border-b border-white/5 bg-[#08080a] py-10" data-testid="partner-carousel">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mb-6">
        <span className="label-tag slash">
          {lang === "gr" ? "ΣΥΝΕΡΓΑΤΕΣ & ΜΑΡΚΕΣ" : "PARTNERS & BRANDS WE WORK WITH"}
        </span>
      </div>
      <div className="overflow-hidden relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#08080a] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#08080a] to-transparent z-10 pointer-events-none" />
        <div className="partner-track flex items-center gap-16 whitespace-nowrap">
          {list.map((item) =>
            item.brand === "amate" ? (
              <Link
                key={item.key}
                to="/brands/amate-audio"
                className="shrink-0 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                data-testid="partner-logo-amate"
                aria-label="Amate Audio"
              >
                <img src="/brands/amate-audio-logo.png" alt="Amate Audio" className="h-10 w-auto object-contain" />
              </Link>
            ) : (
              <span
                key={item.key}
                className="shrink-0 display-font text-xl font-black uppercase tracking-tight text-gray-500 hover:text-white transition-colors duration-300"
              >
                {item.brand}
              </span>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnerCarousel;
